// Module
var code = "<h2 id=\"choose-a-form\">Choose a Form</h2> <p>Our interactive Eligibility Quiz will help determine what option you may be eligible for.</p> ";
// Exports
export default code;